import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.#updateFonte(this.#fonteHidden()?.value ?? "")
    this.#updateBiracoin(this.#indicacaoHidden()?.value ?? "")
  }

  toggle(event) {
    const value = event.detail?.value ?? event.target?.value ?? ""
    this.#updateFonte(value)
  }

  toggleBiracoin(event) {
    const value = event.detail?.value ?? event.target?.value ?? ""
    this.#updateBiracoin(value)
  }

  toggleRepresentante(event) {
    document.getElementById("div_representante")
      ?.classList.toggle("hidden", !event.target.checked)
  }

  #fonteHidden() {
    return this.element.querySelector("input[name='cliente[fonte]'][data-ui--combobox-target='hidden']")
  }

  #indicacaoHidden() {
    return this.element.querySelector("input[name='cliente[indicacao_id]'][data-ui--combobox-target='hidden']")
  }

  #updateFonte(value) {
    const clienteDiv  = document.getElementById("div_fonte_cliente_id")
    const referidoDiv = document.getElementById("div_fonte_referido_id")
    if (clienteDiv)  clienteDiv.style.display  = value === "Cliente"  ? "" : "none"
    if (referidoDiv) referidoDiv.style.display = value === "Referido" ? "" : "none"
  }

  #updateBiracoin(value) {
    const show = value !== "" && value != null
    document.getElementById("div_biracoin1")?.style.setProperty("display", show ? "" : "none")
    document.getElementById("div_biracoin2")?.style.setProperty("display", show ? "" : "none")
  }
}
